module.exports = __webpack_public_path__ + "static/key-heaveho-8b04b89b0719a73f7607f39c218e78fa.webp";